import { render, staticRenderFns } from "./privacyPolicyUS.vue?vue&type=template&id=a8fc1da2&scoped=true"
import script from "./privacyPolicyUS.vue?vue&type=script&lang=js"
export * from "./privacyPolicyUS.vue?vue&type=script&lang=js"
import style0 from "./privacyPolicyUS.vue?vue&type=style&index=0&id=a8fc1da2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fc1da2",
  null
  
)

export default component.exports